import { required, array, obj, optional } from 'AppReact/schema';

const rule = {
  rule_id: required('integer'),
  value: optional(['integer', 'string'])
}

export const badge = {
  name: optional('string'),
  image: optional('string'),
  pending: required('number'),
  achieved: required('number'),
  created_by: optional('string'),
  status_changed_at: optional('jsDate'),
  status_changed_by: optional('string'),
  inserted_at: optional('string'),
  id: optional('integer'),
  type_id: optional('integer'),
  description: optional('string'),
  active: optional('boolean'),
  badge_rules: array(obj(rule)),
};